"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.tokenContext = void 0;
var _react = _interopRequireDefault(require("react"));
var _constants = require("../constants");
var tokenContext = exports.tokenContext = /*#__PURE__*/ _react.default.createContext({
    token: '',
    customerId: _constants.NOT_LOGGED_IN_USER_ID,
    formattedToken: '',
    isAnonymousUser: true,
    isUserVerified: false
}); //# sourceMappingURL=tokenContext.js.map
